export default {

  // 접속한 계정에 노출되는 메뉴 리스트
  list:[],

  pageTitle: '',
  pagePath:[],

  // 사용가능한 boardIds, 대시보드 표기 여부를 판단하기 위해 사용하고 있음.
  availableBoardIds: [],

  // 페이지 번역기능 사용여부
  pageTranslate: false,
  // 페이지 번역 버튼 표시 가능 여부
  canUsePageTranslate: false,
}
